import { ReneoLogo } from '@/shared/components/ui/reneo-logo';

export function AuthorizationHeroPanel() {
    return (
        <section className="relative hidden min-h-screen w-1/2 flex-col justify-between overflow-hidden bg-[#004D57] p-12 text-white sm:flex lg:p-16">
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -left-1/2 -top-1/2 h-full w-full rounded-full bg-[#01233C]/40 blur-3xl" aria-hidden="true" />
                <div className="absolute -bottom-1/2 -right-1/2 h-full w-full rounded-full bg-[#01233C]/30 blur-3xl" aria-hidden="true" />
                <div
                    className="absolute inset-0 opacity-20"
                    style={{ backgroundImage: 'linear-gradient(to bottom right, transparent 40%, rgb(147 217 223 / 0.15) 100%)' }}
                    aria-hidden="true"
                />
            </div>

            <div className="relative">
                <ReneoLogo className="h-auto w-[148px] [&_path]:fill-white" />
            </div>

            <div className="relative flex flex-col gap-8">
                <div>
                    <h2 className="mb-4 text-3xl font-bold tracking-tight lg:text-4xl">Welcome to RCS</h2>
                    <p className="max-w-[430px] text-[15px] leading-[1.75] text-[#93D9DF]/90">
                        Sign in with your Reneo account (OneLogin SSO) or use email and password for external users.
                    </p>
                </div>
            </div>

            <div className="relative text-[12px] text-[#93D9DF]/80">Reneo Group · RCS</div>
        </section>
    );
}
